module.exports = __webpack_public_path__ + "img/zhu7.e1b24632.png";